<template>
  <el-row >
    <el-row style="width:70%; margin:0 auto; ">
      <!-- 标签 --> 
      <el-row >
        <el-menu
          default-active="/MyBill"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b">
          <el-menu-item index="/MyBill">学期缴费</el-menu-item>
          <el-menu-item index="/MyBillHistory">学期缴费历史</el-menu-item>
          <el-menu-item index="/MyBillExam">其他缴费</el-menu-item>
          <el-menu-item index="/MyBillHistoryExam">其他缴费历史</el-menu-item>
          <el-menu-item index="/Card">银行卡</el-menu-item>
          <el-menu-item index="/Exit">退出</el-menu-item>
        </el-menu>
        <br>
        <br>
      </el-row>
      <!-- 缴费类型选择 -->
      <el-row v-show="feeTypeVisible" class="back-up" style="background-color: #fff;">
        <el-row style="text-align:center;margin-top:30px;">
          <el-radio v-model="radio" label="0" border>按学年</el-radio>
          <el-radio v-model="radio" label="1" border>按学期</el-radio>
          <el-row style="margin: 20px auto"><el-button style="width: 50%" type="success" @click="nextFee()">下一步</el-button></el-row>
        </el-row>
      </el-row>
      <!-- 学期缴费 -->
      <el-row v-show="semesterPayVisible" style="background-color: #fff;">
        <div class="notice" v-if="semesterPayVisible && tipText !== ''">
          <van-notice-bar left-icon="volume-o" :text=tipText />
        </div>
        <el-row v-show="false" style="background-color: #fff; text-align: center;">
          <img style="margin-top: 12px;border-radius: 8px;" src="" width="90" height="120">
        </el-row>
        <el-row v-show="billVisible">
          <el-form :model="viewForm" ref="viewForm" label-width="100px" label-position="left" style="width: 50%;background-color: #fff;margin:auto">
            <el-form-item label="学号" class="form-item">
              <span>{{ viewForm.studentNo }}</span>
            </el-form-item>
            <el-form-item label="姓名" class="form-item">
              <span>{{ viewForm.studentName }}</span>
            </el-form-item>
            <el-form-item label="专业"  class="form-item">
              <span>{{ viewForm.majorMatr }}</span>
            </el-form-item>
            <el-form-item label="班级" class="form-item">
              <span>{{ viewForm.className }}</span>
            </el-form-item>
            <el-form-item label="学年"  class="form-item">
              <span>{{ viewForm.academicYear }}</span>
            </el-form-item>
            <!-- <el-form-item label="学期"  class="form-item">
              <span>{{ viewForm.termNM }}</span>
            </el-form-item> -->
            <el-form-item label="应缴总额"  class="form-item" >
              <span>{{ Ginkgo.format(viewForm.payableAmount, 'money') }}</span>
            </el-form-item>
            <el-form-item label="减免总额"  class="form-item" >  
              <span>{{ Ginkgo.format(viewForm.reduceAmount, 'money') }}</span>
            </el-form-item>
            <el-form-item label="实缴总额"  class="form-item" >
              <span>{{ Ginkgo.format(viewForm.feeAmount, 'money') }}</span>
            </el-form-item>
              <el-collapse >
                <el-collapse-item title="费用明细" name="1" style="width: 100%">
                  <el-row>
                    <!-- <div ><span class="label_detail">保险费</span><span class="label_value">100.00</span></div> -->
                    <div v-for="item in feeData" :key="item.feeNo">
                      <span class="label_detail">{{ item.feeName }}</span><span class="label_value">{{ Ginkgo.format(item.feeAmount, 'money') }}</span>
                    </div>
                    <div v-for="item in reduceList" :key="item.feeNo">
                      <span class="label_detail">{{ item.feeNo }}</span><span class="label_value">{{ Ginkgo.format(item.feeAmount, 'money') }}</span>
                    </div>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
          </el-form>
        </el-row>
        <el-row v-show="examBillVisible">
          <el-form :model="viewForm" ref="viewForm" label-width="100px" label-position="left" style="width: 50%;background-color: #fff;margin:auto">
            <el-form-item label="学号" class="form-item">
              <span>{{ viewForm.studentNo }}</span>
            </el-form-item>
            <el-form-item label="姓名" class="form-item">
              <span>{{ viewForm.studentName }}</span>
            </el-form-item>
            <el-form-item label="专业"  class="form-item">
              <span>{{ viewForm.majorMatr }}</span>
            </el-form-item>
            <el-form-item label="班级" class="form-item">
              <span>{{ viewForm.className }}</span>
            </el-form-item>
            <el-form-item label="学年"  class="form-item">
              <span>{{ viewForm.academicYear }}</span>
            </el-form-item>
            <el-form-item label="学期"  class="form-item">
              <span>{{ viewForm.termNM }}</span>
            </el-form-item>
            <el-form-item label="总额"  class="form-item" >
              <span>{{ Ginkgo.format(viewForm.totals, 'money') }}</span>
            </el-form-item>
              <el-collapse >
                <el-collapse-item title="费用明细"  style="width: 100%">
                  <el-row>
                    <el-table ref="feeResultTable" :data="feeData" @selection-change="handleSelectionChange" @row-click="isShow" >
                      <el-table-column type="selection" >
                      </el-table-column>
                      <el-table-column label="费用项" prop="feeNo">
                      </el-table-column>
                      <el-table-column label="金额" prop="feeAmount" :formatter="dataFormat" align="right" >
                      </el-table-column>
                    </el-table>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
          </el-form>
        </el-row>
        <el-row v-show="termVisible" >
          <span >{{ termMsg }}</span>
        </el-row>
        <el-row style="text-align:center;padding:10px 0" >
          <el-button style="width: 25%" type="success" @click="back()" v-if="backVisible">上一步</el-button>
          <el-button style="width: 25%" type="primary" @click="toPay()" :disabled="payButtonDisable" v-if="feePayType_UN">支 付</el-button>
        </el-row>
      </el-row>
      <!-- 历史查询结果窗体 -->
      <el-row v-show="feeListHistoryVisible">
        <el-table ref="resultTable" :data="tableData"
          style="width: 100%; margin-top: 10px;" @sort-change="handleSortChangeHistory" highlight-current-row stripe border :height="global.tableHeight"
        >
          <el-table-column type="index" fixed width="60">
          </el-table-column>
          <!-- 数据列 -->
          <el-table-column
            v-for="item in getUISetQueryResult('01')" :key="item.columnName" :prop="item.columnProp" :label="item.columnDesc.split('|')[0]"
              :min-width="item.colWidth" :align="item.alignType" :formatter="dataFormatHistory"
              :fixed="Ginkgo.getColumnFixed(item)" sortable="custom" header-align="center"
            v-if="getHeaderVisible(item, 1)"
          >
            <el-table-column
              v-for="item2 in getHeaderGroup(item, 2, '01')" :key="item2.columnName" :prop="item2.columnProp" :label="item2.columnDesc.split('|')[1]"
                :min-width="item2.colWidth" :align="item2.alignType" :formatter="dataFormatHistory"
                :fixed="Ginkgo.getColumnFixed(item2)" sortable="custom" header-align="center"
              v-if="getHeaderVisible(item2, 2)"
            >
              <el-table-column
                v-for="item3 in getHeaderGroup(item2, 3, '01')" :key="item3.columnName" :prop="item3.columnProp" :label="item3.columnDesc.split('|')[2]"
                  :min-width="item3.colWidth" :align="item3.alignType" :formatter="dataFormatHistory"
                  :fixed="Ginkgo.getColumnFixed(item3)" sortable="custom" header-align="center"
                v-if="getHeaderVisible(item3, 3)"
              >
              </el-table-column>
            </el-table-column>
          </el-table-column>
        </el-table>
        <el-pagination style="text-align: center;" @size-change="handleSizeChangeHistory" @current-change="handleCurrentChangeHistory"
          :current-page="page.number + 1" :page-sizes="page.pageSizes" :page-size="page.size" layout="total, sizes, prev, pager, next, jumper"
          :total="page.totalElements" :page-count="page.totalPages"
        >
        </el-pagination>
      </el-row>
      <!-- 历史考试费查询结果窗体 -->
      <el-row v-show="examListHistoryVisible">
        <el-table ref="resultTable" :data="tableData"
          style="width: 100%; margin-top: 10px;" @sort-change="handleSortChangeHistory" highlight-current-row stripe border :height="global.tableHeight"
        >
          <el-table-column type="index" fixed width="60">
          </el-table-column>
          <!-- 数据列 -->
          <el-table-column
            v-for="item in getUISetQueryResult('02')" :key="item.columnName" :prop="item.columnProp" :label="item.columnDesc.split('|')[0]"
              :min-width="item.colWidth" :align="item.alignType" :formatter="dataFormatExamHistory"
              :fixed="Ginkgo.getColumnFixed(item)" sortable="custom" header-align="center"
            v-if="getHeaderVisible(item, 1)"
          >
            <el-table-column
              v-for="item2 in getHeaderGroup(item, 2, '02')" :key="item2.columnName" :prop="item2.columnProp" :label="item2.columnDesc.split('|')[1]"
                :min-width="item2.colWidth" :align="item2.alignType" :formatter="dataFormatExamHistory"
                :fixed="Ginkgo.getColumnFixed(item2)" sortable="custom" header-align="center"
              v-if="getHeaderVisible(item2, 2)"
            >
              <el-table-column
                v-for="item3 in getHeaderGroup(item2, 3, '02')" :key="item3.columnName" :prop="item3.columnProp" :label="item3.columnDesc.split('|')[2]"
                  :min-width="item3.colWidth" :align="item3.alignType" :formatter="dataFormatExamHistory"
                  :fixed="Ginkgo.getColumnFixed(item3)" sortable="custom" header-align="center"
                v-if="getHeaderVisible(item3, 3)"
              >
              </el-table-column>
            </el-table-column>
          </el-table-column>
        </el-table>
        <el-pagination style="text-align: center;" @size-change="handleSizeChangeHistory" @current-change="handleCurrentChangeHistory"
          :current-page="page.number + 1" :page-sizes="page.pageSizes" :page-size="page.size" layout="total, sizes, prev, pager, next, jumper"
          :total="page.totalElements" :page-count="page.totalPages"
        >
        </el-pagination>
      </el-row>
      <!-- 关注微信 -->
      <el-row>
        <el-dialog title="微信二维码" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
          <el-row style="text-align:center;padding:10px 0">
            <img :src="weixin" />
          </el-row>
        </el-dialog>
      </el-row>
      <!-- 支付选择页面 -->
      <el-row v-show="payVisible">
        <el-row v-show="buttonVisiblePFWX">
          <mt-cell title="微信支付" v-on:click.native="doPay(payTypePFWX)" value="使用微信支付，方便快捷" style="min-height: 65px;" is-link>
            <img slot="icon" :src="wx" width="50" height="45">
          </mt-cell>
        </el-row>
        <el-row v-show="buttonVisiblePFZFB">
          <mt-cell title="支付宝支付" v-on:click.native="doPay(payTypePFZFB)" value="使用支付宝支付，方便快捷" style="min-height: 65px;" is-link>
            <img slot="icon" :src="zfb" width="50" height="45">
          </mt-cell>
        </el-row>
        <el-row v-show="buttonVisibleWX">
          <mt-cell title="微信支付" v-on:click.native="doPay(payType)" value="使用微信支付，方便快捷" style="min-height: 65px;" is-link>
            <img slot="icon" :src="wx" width="50" height="45">
          </mt-cell>
        </el-row>
        <el-row v-show="buttonVisibleZFB">
          <mt-cell title="支付宝支付" v-on:click.native="doPay(payTypeZFB)" value="使用支付宝支付，方便快捷" style="min-height: 65px;" is-link>
            <img slot="icon" :src="zfb" width="50" height="45">
          </mt-cell>
        </el-row>
        <el-row v-show="buttonVisibleUnion">
          <mt-cell title="银联支付" v-on:click.native="doPay(payTypeUnion)" value="使用银联支付，优惠多多" style="min-height: 65px;" is-link>
            <img slot="icon" :src="yl" width="50" height="45">
          </mt-cell>
        </el-row>
      </el-row>
      <!-- 扫码页面 -->
      <el-row v-show="scanVisible">
        <div style="display: flex;flex-direction: column;align-items: center;">
          <vue-qr style="width: 30%;" :logoSrc="qrImage" :text="qrContent" :size="200"></vue-qr>
          <el-row style="text-align:center;padding:10px 0">
            <el-button type="success" @click="setVisible('10')">上一步</el-button>
          </el-row>
        </div>
      </el-row>
    </el-row>
  </el-row>
</template>
<script>
import vueQr from 'vue-qr'
import vanNoticeBar from 'vant/lib/notice-bar'
import 'vant/lib/notice-bar/style'

export default {
  name: 'MyBillXiFan',
  components: { vueQr, vanNoticeBar },
  data: function () {
    return {
      form: {
        studentType: '02',
        studentName: '',
        studentNo: '',
        idCard: ''
      },
      viewForm: {
        studentNo: '',
        studentName: '',
        majorMatr: '',
        className: '',
        academicYear: '',
        term: '',
        termNM: '',
        enrollmentYear: 0, // 学籍
        deptName: '', // 院系
        trainingLevel: '', // 培养层次
        tuition: 0,
        houseFees: 0,
        totals: 0,
        payableAmount: 0,
        feeAmount: 0,
        reduceAmount: 0 // 减免总金额
      },
      payTerm: {
        stdt: 0, // 缴费开始日期
        endt: 0, // 缴费结束日期
        academicYear: '', // 学年
        term: '', // 学期
        isPayTerm: ''
      },
      tableData: [],  // table绑定数据
      uiSetItemList: [], // 原始
      feeData: [], // 费用明细
      termList: [], // 账期列表
      reduceList: [], // 减免账单
      orderInfoList: [], // 缴费历史
      orderInfoListByType: [], // 各类型缴费历史
      viDeptSetList: [],
      modeSelectList: [],
      multipleSelection: [],
      checked: false,
      feeType: '01', // 学期缴费
      feeTypeVisible: false, // 缴费类型
      feeList: [],  // 费用数据
      radio: '0',
      backVisible: false, // 返回按钮
      // 分页对象
      page: this.Ginkgo.cloneObj(this.global.page),
      // ！！！初始排序对象
      sort: {},
      sortSet: [],
      photo: '',
      dialogFormVisible: false,
      semesterPayVisible: false,
      feePayType_UN: false,
      payButtonDisable: false,
      feeListHistoryVisible: false,
      billVisible: false,
      termVisible: false,
      termMsg: '不在缴费期内',
      examBillVisible: false,
      examListHistoryVisible: false,
      weixin: this.global.staticResourceAddr + 'gsvvuepc/zft2Code.jpg',

      financeOffice: {},
      apartmentOffice: {},
      deanOffice: {},
      admissionsOffice: {},
      technicalSupport: {},
      informationManagementCenter: {},
      customerService: {},
      // 支付相关
      payVisible: false,

      scanVisible: false,
      qrContent: '',
      qrImage: '',

      buttonVisibleWX: false,
      buttonVisibleZFB: false,
      buttonVisibleUnion: false,
      buttonVisiblePFWX: false,
      buttonVisiblePFZFB: false,

      payType: '',
      payTypeZFB: '',
      payTypeUnion: '01',
      payTypeHTT: '',
      payTypeZJ: '',
      payTypeUnionWX: '',
      payTypePFWX: '',
      payTypePFZFB: '',

      // 图片
      wx: this.global.staticResourceAddr + 'gsvxifanvuem/' + this.global.theme + '/images/wx.png',
      yl: this.global.staticResourceAddr + 'gsvxifanvuem/' + this.global.theme + '/images/yl.png',
      zfb: this.global.staticResourceAddr + 'gsvxifanvuem/' + this.global.theme + '/images/zfb.png',
      // 通知信息
      tipText: ''
    }
  },
  mounted: function () {
    console.log('====', this.global.curStudent)
    if (process.env.NODE_ENV === 'production') {
      this.getMode()
      this.getUISet()
      // this.getDeptSet()
      this.getHistory()
      this.viewForm.studentNo = this.global.curStudent.studentNo
      this.viewForm.studentName = this.global.curStudent.studentName
      this.viewForm.majorMatr = this.global.curStudent.majorMatr
      this.viewForm.className = this.global.curStudent.className
      this.viewForm.enrollmentYear = this.global.curStudent.enrollmentYear
      this.viewForm.trainingLevel = this.global.curStudent.trainingLevel
      this.viewForm.deptName = this.global.curStudent.deptName
      if (this.global.curStudent.studentType === '02') { // 老生校验缴费期
        this.checkTerm()
      }
    } else {
      this.viewForm = {
        studentNo: '17611070628',
        studentName: '陈彦羽',
        majorMatr: '学前教育',
        className: '三七班',
        academicYear: '2018',
        term: '0',
        tuition: 1520,
        houseFees: 1200,
        totals: 0,
        payableAmount: 0,
        feeAmount: 0
      }
      this.viewForm.tuition = this.Ginkgo.format(this.viewForm.tuition, 'money')
      this.viewForm.houseFees = this.Ginkgo.format(this.viewForm.houseFees, 'money')
      this.viewForm.payableAmount = this.Ginkgo.format(this.viewForm.tuition + this.viewForm.houseFees, 'money')
      this.viewForm.feeAmount = this.Ginkgo.format(this.viewForm.tuition + this.viewForm.houseFees, 'money')
      this.setVisible('01')
    }
  },
  methods: {
    // 初始化数据字典
    getMode: function () {
      var self = this
      self.modeSelectList = self.global.modeList
    },
    // 加载界面配置
    getUISet: function () {
      var self = this
      self.uiSetItemList = self.global.uiSetItemList
      self.uiSetList = self.global.uiSetList
    },
    setVisible: function (showType) {
      if (showType === '01') { // 基础缴费我的账单，显示账单信息
        this.semesterPayVisible = true
        this.feePayType_UN = true
        this.feeListHistoryVisible = false
        this.billVisible = true
        this.termVisible = false
        this.examBillVisible = false
        this.examListHistoryVisible = false
        this.payButtonDisable = true
        this.feeTypeVisible = false
        this.payVisible = false
        this.scanVisible = false
      }
      if (showType === '02') { // 提示信息
        this.semesterPayVisible = true
        this.feePayType_UN = false
        this.feeListHistoryVisible = false
        this.billVisible = false
        this.termVisible = true
        this.examBillVisible = false
        this.examListHistoryVisible = false
        this.payButtonDisable = true
        this.feeTypeVisible = false
        this.payVisible = false
        this.scanVisible = false
      }
      if (showType === '03') { // 历史账单（基础缴费）
        this.feeListHistoryVisible = true
        this.semesterPayVisible = true
        this.feePayType_UN = false
        this.billVisible = false
        this.termVisible = false
        this.examBillVisible = false
        this.examListHistoryVisible = false
        this.payButtonDisable = true
        this.feeTypeVisible = false
        this.payVisible = false
        this.scanVisible = false
      }
      if (showType === '04') { // 考试缴费账单，显示账单信息
        this.semesterPayVisible = true
        this.examBillVisible = true
        this.feePayType_UN = true
        this.feeListHistoryVisible = false
        this.billVisible = false
        this.termVisible = false
        this.examListHistoryVisible = false
        this.payButtonDisable = true
        this.feeTypeVisible = false
        this.payVisible = false
        this.scanVisible = false
      }
      if (showType === '06') { // 历史账单（考试缴费）
        this.feeListHistoryVisible = false
        this.semesterPayVisible = true
        this.feePayType_UN = false
        this.billVisible = false
        this.termVisible = false
        this.examBillVisible = false
        this.examListHistoryVisible = true
        this.payButtonDisable = true
        this.feeTypeVisible = false
        this.payVisible = false
        this.scanVisible = false
      }
      if (showType === '07') { // 账期选择
        this.feeListHistoryVisible = false
        this.semesterPayVisible = false
        this.feePayType_UN = false
        this.billVisible = false
        this.termVisible = false
        this.examBillVisible = false
        this.examListHistoryVisible = false
        this.payButtonDisable = false
        this.feeTypeVisible = true
        this.payVisible = false
        this.scanVisible = false
      }
      if (showType === '10') { // 支付选择页面
        this.feeListHistoryVisible = false
        this.semesterPayVisible = false
        this.feePayType_UN = false
        this.billVisible = false
        this.termVisible = false
        this.examBillVisible = false
        this.examListHistoryVisible = false
        this.payButtonDisable = false
        this.feeTypeVisible = false
        this.payVisible = true
        this.scanVisible = false
      }
      if (showType === '11') { // 支付页面
        this.payVisible = false
        this.scanVisible = true
      }
    },
    back: function (type) {
      this.setVisible('07')
    },
    isShow(row, event, column) {
      if (row.isExpanded === 0) {
        this.$refs.feeResultTable.toggleRowExpansion(row, true)
        row.isExpanded = 1
      } else {
        this.$refs.feeResultTable.toggleRowExpansion(row, false)
        row.isExpanded = 0
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
      var self = this
      self.viewForm.totals = 0
      self.termList = []
      val.forEach(function (e) {
        self.viewForm.totals = self.viewForm.totals + Number(e.feeAmount)
        self.termList.push(e.term)
      })
      if (self.viewForm.totals === 0) {
        self.payButtonDisable = true
      } else {
        self.payButtonDisable = false
      }
    },
    // 校验是否在缴费期中
    checkTerm: function () {
      var self = this
      let termInfo = this.modeSelectList.filter(function (element) {
        return element.typeId === 'CM_OldStuPayTime'
      })
      if (termInfo.length > 0) {
        self.payTerm.stdt = termInfo[0].field2
        self.payTerm.endt = termInfo[0].field3
        self.payTerm.academicYear = termInfo[0].modeValue.substring(0, 4)
        self.viewForm.academicYear = termInfo[0].modeValue

        self.tipText = termInfo[0].field4
        let newDate = self.Ginkgo.dateToInt(new Date())
        if (newDate >= self.payTerm.stdt && newDate <= self.payTerm.endt) {
          self.global.curUser.schoolYear = termInfo[0].modeValue.substring(0, 4)
          self.payTerm.isPayTerm = '1' // 是在缴费期内
          self.checkTermMode('0')
        } else {
          if (!termInfo[0].field4) {
            self.termMsg = '不在缴费期内'
          } else {
            self.termMsg = termInfo[0].field4
          }
          self.payTerm.isPayTerm = '0'
          console.log('payTerm:', self.payTerm)
          self.setVisible('02')
        }
      } else {
        self.termMsg = '不在缴费期内'
        self.payTerm.isPayTerm = '0'
        console.log('payTerm:', self.payTerm)
        self.setVisible('02')
      }
    },
    toLoan: function () { // 登录页面
      this.$router.push('/LoanXiFan')
      this.route = [{ path: '/LoanXiFan', component: require('./LoanXiFan.vue'), meta: { title: '生源地贷款' } }]
      this.$router.addRoutes(this.route)
    },
    // 校验学期数据字典
    checkTermMode: function (type) {
      let termRow = this.modeSelectList.filter(function (element) {
        return element.typeId === 'Term_XF' && element.modeId === type
      })[0]
      console.log('termRow', termRow)
      this.viewForm.term = termRow.modeId
      this.viewForm.termNM = termRow.modeName
      this.payTerm.term = termRow.modeId
      console.log('viewForm', this.viewForm)
      if (this.global.curStudent.isYearFee === '1') { // 学年缴费
        this.billGetNew()
      } else {
        this.billGet()
      }
    },
    // 校验老生导入费用是否在缴费期中
    checkTermOldStuImp: function () {
      var self = this
      let termInfo = this.modeSelectList.filter(function (element) {
        return element.typeId === 'CM_OldStuImpPayTime'
      })
      if (termInfo.length > 0) {
        console.log('termInfo:', termInfo)
        let stdt = termInfo[0].field2
        let endt = termInfo[0].field3

        self.tipText = termInfo[0].field4
        let newDate = self.Ginkgo.dateToInt(new Date())
        if (newDate >= stdt && newDate <= endt) {
          self.setVisible('04')
          self.examBillGet()
        } else {
          if (!termInfo[0].field4) {
            self.termMsg = '不在缴费期内'
          } else {
            self.termMsg = termInfo[0].field4
          }
          self.setVisible('02')
        }
      } else {
        self.termMsg = '不在缴费期内'
        self.setVisible('02')
      }
    },
    // 新收费方式
    billGetNew: function () { // 账单查询
      var self = this
      // 初始化
      let request = {}
      request.idIf = '60'
      request.deptId = self.global.deptId
      request.itemList = [
        {paramName: 'studentNo', paramValue: self.global.curStudent.studentNo},
        {paramName: 'studYear', paramValue: self.payTerm.academicYear},
        {paramName: 'studTerm', paramValue: '0'}
      ]
      this.axios.post('/iif/accessIfForHttp', request
      )
      .then(function (response) {
        if (response.data.result.success === true) {
          let obj = response.data.responseObj
          if (obj.result.success === true) {
            // 已缴费
            let studBill = obj.studBillList.filter(item => item.feeNo === 'SF01')[0]
            if (studBill.feeAmount > 0 && studBill.paidfeeAmount === studBill.feeAmount) {
              self.termMsg = '已缴费！'
              self.setVisible('02')
            } else if (studBill.paidfeeAmount > 0) {
              self.termMsg = '账单设置不正确，存在已交金额，请联系学校！'
              self.setVisible('02')
            } else {
              if (self.global.isLoan === '1') {
                self.global.isLoan = '0'
                self.setVisible('01')
                self.feeData = obj.studBillList
                console.log('111111')
                self.reduceGet()
              } else {
                // 进入贷款页面
                self.toLoan()
              }
            }
          } else {
            self.termMsg = obj.result.msg
            self.setVisible('02')
          }
        } else {
          self.$alert(response.data.result.msg)
        }
      }, response => {
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    billGet: function () { // 账单查询
      var self = this
      // 初始化
      let request = {}
      request.idIf = '60'
      request.deptId = self.global.deptId
      request.itemList = [
        {paramName: 'studentNo', paramValue: self.global.curStudent.studentNo},
        {paramName: 'studYear', paramValue: self.payTerm.academicYear},
        {paramName: 'studTerm', paramValue: '0'}
      ]
      this.axios.post('/iif/accessIfForHttp', request
      )
      .then(function (response) {
        if (response.data.result.success === true) {
          let obj = response.data.responseObj
          if (obj.result.success === true) {
            self.feeList = obj.studBillList
            let studBill = obj.studBillList.filter(item => item.feeNo === 'SF01')[0]
            // 选学期未缴费
            if (studBill.paidfeeAmount === 0) {
              if (self.global.isLoan === '0') {
                // 进入贷款页面
                self.toLoan()
              } else {
                // 显示账期选择
                self.global.isLoan = '0'
                self.backVisible = true
                self.setVisible('07')
              }
            }
            // 第二学期
            if (studBill.paidfeeAmount > 0 && studBill.paidfeeAmount < studBill.feeAmount) {
              // 先校验欠费金额
              let termRow = self.modeSelectList.filter(function (element) {
                return element.typeId === 'Term_XF' && element.modeId === '1'
              })[0]
              console.log('termRow', termRow)
              self.viewForm.term = termRow.modeId
              self.viewForm.termNM = termRow.modeName
              self.payTerm.term = termRow.modeId
              self.queryOrderInfoXiFan('1')
            }
            // 已缴费
            if (studBill.paidfeeAmount === studBill.feeAmount) {
              self.termMsg = '已缴费！'
              self.setVisible('02')
            }
          } else {
            self.termMsg = obj.result.msg
            self.setVisible('02')
          }
        } else {
          self.$alert(response.data.result.msg)
        }
      }, response => {
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    // 下一步 显示账单
    nextFee: function () {
      var self = this
      this.feeData = []
      // 选学年
      if (this.radio === '0') {
        this.feeData = this.feeList
        console.log('2222222')
        this.reduceGet()
        this.setVisible('01')
      }
      // 选学期
      if (this.radio === '1') {
        // 显示账单
        let tmpList = []
        let feeListTemp = this.Ginkgo.cloneObj(this.feeList)
        feeListTemp.forEach(function (ele) {
          if (ele.feeNo === 'SF01' || ele.feeNo === 'SF02') {
            ele.feeAmount = ele.feeAmount / 2
            tmpList.push(ele)
          } else {
            tmpList.push(ele)
          }
        })
        self.feeData = tmpList
        console.log('33333333')
        self.reduceGet()
        self.setVisible('01')
        // 新增西翻账单
        self.addOrderInfoXiFan()
      }
    },
    // 获取订单信息
    queryOrderInfoXiFan: function (term) {
      var self = this
      if (process.env.NODE_ENV === 'production') {
        this.axios.post('/college/getStudBillXiFan', {
          studNo: self.global.curStudent.studentNo,
          studYear: self.payTerm.academicYear,
          studTerm: term
        })
        .then(function (response) {
          if (response.data.result.success === true) {
            let feeList = response.data.studBillXiFanList
            if (feeList.length !== 0) {
              let feeAmountSum = 0
              let feeAmountSum2 = 0
              // 本地库账单
              for (let index = 0; index < feeList.length; index++) {
                feeAmountSum = feeAmountSum + Number(feeList[index].feeAmount)
              }
              // 西翻库账单
              for (let index = 0; index < self.feeList.length; index++) {
                if (self.feeList[index].feeNo === 'SF01' || self.feeList[index].feeNo === 'SF02') {
                  feeAmountSum2 = feeAmountSum2 + (Number(self.feeList[index].feeAmount) - Number(self.feeList[index].paidfeeAmount))
                }
              }
              if (feeAmountSum === feeAmountSum2) {
                self.feeData = feeList
                console.log('44444444444')
                self.reduceGet()
                self.setVisible('01')
              } else {
                self.termMsg = '欠费金额有变动，请联系学校！'
                self.setVisible('02')
              }
            } else {
              self.termMsg = '找不到本地订单！'
              self.setVisible('02')
            }
          } else {
            self.$alert('Error 服务异常！')
          }
        }, response => {
        })
        .catch(function (error) {
          console.log(error)
        })
      }
    },
    // 新增订单信息
    addOrderInfoXiFan: function () {
      var self = this
      let tmpList = []
      let tmpRow = {}
      let feeListTemp = this.Ginkgo.cloneObj(this.feeList)
      feeListTemp.forEach(function (ele) {
        tmpRow = {}
        tmpRow.studNo = self.global.curStudent.studentNo
        tmpRow.studYear = ele.studYear
        tmpRow.studTerm = '0'
        tmpRow.feeNo = ele.feeNo
        tmpRow.feeName = ele.feeName
        if (ele.feeNo === 'SF01' || ele.feeNo === 'SF02') {
          tmpRow.feeAmount = ele.feeAmount / 2
        } else {
          tmpRow.feeAmount = ele.feeAmount
        }
        tmpList.push(tmpRow)
        if (ele.feeNo === 'SF01' || ele.feeNo === 'SF02') {
          tmpRow = {}
          tmpRow.studNo = self.global.curStudent.studentNo
          tmpRow.studYear = ele.studYear
          tmpRow.studTerm = '1'
          tmpRow.feeNo = ele.feeNo
          tmpRow.feeName = ele.feeName
          tmpRow.feeAmount = ele.feeAmount / 2
          tmpList.push(tmpRow)
        }
      })
      if (process.env.NODE_ENV === 'production') {
        this.axios.post('/college/addStudBillXiFan', tmpList)
        .then(function (response) {
          if (response.data.result.success === true) {
            console.log('订单新增成功')
          }
        }, response => {
        })
        .catch(function (error) {
          console.log(error)
        })
      }
    },
    // 减免账单查询
    reduceGet: function () {
      if (process.env.NODE_ENV === 'production') {
        var self = this
        self.axios.get('/college/getOrderInfoXiFan', { params: {
          deptId: self.global.deptId,
          term: '',
          keyInfo: self.global.curStudent.studentNo,
          statusCode: '02',
          field1: '',
          field2: '减免',
          field3: '',
          field4: self.viewForm.academicYear,
          field5: '',
          field6: '',
          field7: '',
          field8: '',
          field9: '',
          field10: ''
        }})
        .then(function (response) {
          if (response.data.result.success === true) {
            self.reduceList = response.data.orderInfoList
            self.viewForm.payableAmount = 0
            self.viewForm.feeAmount = 0
            self.viewForm.reduceAmount = 0
            for (let index = 0; index < self.feeData.length; index++) {
              self.viewForm.payableAmount = self.viewForm.payableAmount + Number(self.feeData[index].feeAmount)
              self.viewForm.feeAmount = self.viewForm.feeAmount + Number(self.feeData[index].feeAmount)
            }
            if (self.reduceList.length !== 0) { // 如果减免账单不为空，根据减免信息计算实缴金额
              for (let index = 0; index < self.reduceList.length; index++) {
                self.viewForm.feeAmount = self.viewForm.feeAmount - Math.abs(Number(self.reduceList[index].feeAmount))
                self.viewForm.reduceAmount = self.viewForm.reduceAmount + Number(self.reduceList[index].feeAmount)
              }
              console.log('self.viewForm:', self.viewForm)
            }
            if (self.viewForm.feeAmount < 0) {
              self.$alert('实缴金额为负值，' + self.viewForm.feeAmount + ' 元，不允许支付！')
              self.payButtonDisable = true
            } else if (self.viewForm.feeAmount === 0) {
              self.$alert('实缴金额为 ' + self.viewForm.feeAmount + ' 元，不允许支付！')
              self.payButtonDisable = true
            } else {
              self.payButtonDisable = false
            }
          }
        }, response => {
        })
        .catch(function (error) {
          console.log(error)
        })
      }
    },
    toPay: function () {
      this.checkPayTime()
    },
    checkPayTime: function () {
      var self = this
      // self.buttonLoad = true
      self.axios.get('/pay/checkToPay', { params: {
        deptId: self.global.deptId // 1000003
      }})
      .then(function (response) {
        if (response.data.return_msg === 'SUCCESS') {
          if (self.feeType === '01') { // 学期缴费创建订单
            self.createOrderInfo()
          } else { // 考试缴费
            self.getDeptSet()
          }
          // self.buttonLoad = false
        } else {
          // self.buttonLoad = false
          self.$alert(response.data.prop)
        }
      }, response => {
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    // 生成订单信息
    createOrderInfo: function () {
      var self = this
      let orderInfoList = []
      this.termList = []
      this.feeData.forEach(element => {
        let orderInfo = this.Ginkgo.resetForm(this.uiSetItemList, 'tbIf_Order_Info_Common')
        orderInfo.id = 0
        orderInfo.transDt = 0
        orderInfo.term = this.Ginkgo.getTimeStamp() + this.viewForm.academicYear + this.viewForm.term + element.feeName // 处理账期
        orderInfo.statusCode = '02' // 初始核准状态
        orderInfo.field12 = '01' // 老生学期缴费
        orderInfo.deptId = self.global.deptId
        orderInfo.keyInfo = this.viewForm.studentNo
        orderInfo.field1 = this.viewForm.studentName
        orderInfo.field2 = this.viewForm.majorMatr
        orderInfo.field3 = this.viewForm.className
        orderInfo.field4 = this.viewForm.academicYear
        orderInfo.field5 = this.viewForm.term
        orderInfo.field6 = this.viewForm.termNM
        orderInfo.field7 = this.viewForm.enrollmentYear
        orderInfo.field8 = this.viewForm.trainingLevel
        orderInfo.field9 = this.viewForm.deptName
        orderInfo.feeNo = element.feeName
        orderInfo.field10 = element.feeNo
        orderInfo.payableAmount = element.feeAmount
        orderInfo.feeAmount = element.feeAmount
        orderInfo.remark = '银行数据导入'
        orderInfo.idIf = 60
        orderInfoList.push(orderInfo)
        this.termList.push(orderInfo.term)
      })
      if (this.reduceList.length > 0) {
        this.reduceList.forEach(function (ele) {
          self.termList.push(ele.term)
        })
      }
      this.axios.post('/iif/addOrderInfoList', orderInfoList
      )
      .then(function (response) {
        if (response.data.result.success === true) {
          self.getDeptSet()
          // self.buttonLoad = false
        } else {
          // self.buttonLoad = false
          self.$alert('生成账单失败！')
        }
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    // 获取机构支付配置
    getDeptSet: function () {
      var self = this
      self.axios.get('/college/getBaseDeptSetByDeptID', { params: {
        deptId: self.global.deptId
      }})
      .then(function (response) {
        // 机构配置信息
        if (response.data.result.success === true) {
          self.viDeptSetList = response.data.viDeptSetList
          if (self.viDeptSetList.length > 0) {
            self.setVisiblePayButton(self.viDeptSetList)
          }
        }
        self.buttonLoad = false
      }, response => {
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    setVisiblePayButton: function (merchantList) {
      var self = this
      // 取微信支付相关参数
      let wxPayType = merchantList.filter(item => item.payKind === '02') // payKind：01 银联; 02 微信; 03 支付宝; 04 代扣;
      if (wxPayType.length > 0) { // 有且仅有一个
        self.channelFlag = wxPayType[0].channelFlag
        self.merchantCode = wxPayType[0].merchantCode
      }
      // 设置支付方式的显示隐藏
      self.buttonVisibleUnion = false
      self.buttonVisibleWX = false
      self.buttonVisibleZFB = false
      // 商户配置信息
      if (merchantList.length > 0) {
        merchantList.forEach(function (e) {
          if (e.payKind === '01') { // 银联
            self.payTypeUnion = e.payType
            self.buttonVisibleUnion = true
          }
          if (e.payKind === '02') { // 微信
            self.payType = e.payType
            self.buttonVisibleWX = true
          }
          if (e.payKind === '03') { // 支付宝
            self.payTypeZFB = e.payType
            self.buttonVisibleZFB = true
          }
          if (e.payKind === '07') { // 浦发新微信
            self.payTypePFWX = e.payType
            self.buttonVisiblePFWX = true
          }
          if (e.payKind === '08') { // 浦发新支付宝
            self.payTypePFZFB = e.payType
            self.buttonVisiblePFZFB = true
          }
          if (e.payType === '98') { // 暂无用
            self.payTypeHTT = e.payType
            self.buttonVisibleHTT = true
          }
          if (e.payKind === '04') { // 代扣
            self.payTypeZJ = e.payType
            self.buttonVisibleZJ = true
          }
        })
      }
      self.setVisible('10')
    },
    doPay: function (payType) {
      if (process.env.NODE_ENV === 'production') {
        var self = this
        let payUrl = ''
        let validType = '01'
        if (this.feeType === '01') { // 学期缴费
          validType = '02'
        }
        // 根据不同支付方式访问不同的发起交易服务
        self.axios.post('/pay/toPay', {
          keyInfo: self.viewForm.studentNo,
          deptId: self.global.deptId,
          payType: payType,
          feeTermList: self.termList,
          channelType: '02',
          validType: validType
        })
        .then(function (response) {
          if (response.data.result.success) {
            let payKind = self.viDeptSetList.filter(item => item.payType === payType)[0].payKind
            if (payKind === '02') { // 微信支付
              payUrl += self.global.payUrl + 'pay/doPayForUrl?'
              payUrl += 'payType=' + payType
              payUrl += '&orderNo=' + response.data.orderNo
              payUrl += '&deptId=' + response.data.deptId
              payUrl += '&openId=' + self.global.curUser.openId
              payUrl += '&qrCodeType=' + 'WXPAY'
              payUrl += '&payChannel=01'
              // 二维码
              console.log('===wx支付地址===', payUrl)
              self.qrContent = payUrl
              self.setVisible('11')
            } else if (payKind === '03') {
              payUrl += self.global.payUrl + 'pay/doPayForUrl?'
              payUrl += 'payType=' + payType
              payUrl += '&orderNo=' + response.data.orderNo
              payUrl += '&deptId=' + response.data.deptId
              payUrl += '&openId=' + self.global.curUser.openId
              payUrl += '&qrCodeType=' + 'ALIPAY'
              payUrl += '&payChannel=01'
              // 二维码
              console.log('===支付宝支付地址===', payUrl)
              self.qrContent = payUrl
              self.setVisible('11')
            } else if (payKind === '07') { // 浦发微信支付 新版 opNJK1tn-GZEhIudaMdrRmr4wYs0
              payUrl += self.global.payUrl + 'pay/doPayForUrl?'
              payUrl += 'payType=' + payType
              payUrl += '&orderNo=' + response.data.orderNo
              payUrl += '&deptId=' + response.data.deptId
              payUrl += '&openId=' + self.global.curUser.openId
              payUrl += '&qrCodeType=' + 'WXPAY'
              payUrl += '&payChannel=01'
              console.log('===pfwx支付地址===', payUrl)
              self.qrContent = payUrl
              self.setVisible('11')
            } else if (payKind === '08') { // 浦发支付宝支付 新版 opNJK1tn-GZEhIudaMdrRmr4wYs0
              payUrl += self.global.payUrl + 'pay/doPayForUrl?'
              payUrl += 'payType=' + payType
              payUrl += '&orderNo=' + response.data.orderNo
              payUrl += '&deptId=' + response.data.deptId
              payUrl += '&openId=' + self.global.curUser.openId
              payUrl += '&qrCodeType=' + 'ALIPAY'
              payUrl += '&payChannel=01'
              console.log('===pfzfb支付地址===', payUrl)
              self.qrContent = payUrl
              self.setVisible('11')
            } else {
              payUrl = self.global.payUrl + 'pay/doPay?' + 'payType=' + self.payTypeUnion + '&orderNo=' + response.data.orderNo + '&deptId=' + response.data.deptId + '&openId=&payChannel=02'
              window.location.href = payUrl
            }
          } else {
            self.$alert(response.data.result.msg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        this.setVisible('01')
      }
    },
    showWechatImg: function () {
      this.dialogFormVisible = true
    },
    handleSelect: function (index, indexPath) {
      if (process.env.NODE_ENV === 'production') {
        if (index === '/MyBill') {
          this.feeType = '01'
          if (this.payTerm.isPayTerm === '1') {
            this.viewForm.totals = 0
            this.viewForm.feeAmount = 0
            this.viewForm.reduceAmount = 0
            this.viewForm.payableAmount = 0
            this.feeData = []
            this.setVisible('01')
            this.checkTermMode('0')
          } else {
            this.setVisible('02')
          }
        }
        if (index === '/MyBillExam') {
          this.feeType = '02'
          this.viewForm.totals = 0
          this.feeData = []
          this.checkTermOldStuImp()
        }
        if (index === '/MyBillHistory') {
          this.tableData = []
          this.setVisible('03')
          this.getHistoryByType('')
        }
        if (index === '/MyBillHistoryExam') {
          this.tableData = []
          this.setVisible('06')
          this.getHistoryByType('02')
        }
        if (index === '/Card') {
          this.$router.push('/card')
          this.route = [{ path: '/card', component: require('@/components/XiFan/NewStudent/card'), meta: { title: '银行卡信息维护' } }]
          this.$router.addRoutes(this.route)
        }
        if (index === '/Exit') {
          this.$router.push('/LoginXiFan')
          this.route = [{ path: '/LoginXiFan', component: require('./LoginXiFan.vue'), meta: { title: '缴费登录' } }]
          this.$router.addRoutes(this.route)
        }
      } else {
        if (index === '/MyBill') {
          this.setVisible('02')
        }
        if (index === '/Exit') {
          this.$router.push('/LoginXiFan')
          this.route = [{ path: '/LoginXiFan', component: require('./LoginXiFan.vue'), meta: { title: '缴费登录' } }]
          this.$router.addRoutes(this.route)
        }
      }
    },
    // 获取学生历史缴费信息
    getHistory: function () {
      if (process.env.NODE_ENV === 'production') {
        var self = this
        let request = {}
        request.deptId = self.global.deptId
        request.keyInfo = self.global.curStudent.studentNo
        let str = JSON.stringify(request)
        this.axios.post('/iif/getOrderInfoForHistoryByEncrypt', this.Ginkgo.encrypt(str))
        .then(function (response) {
          let backJson = JSON.parse(self.Ginkgo.rsaDecrypt(response.data))
          if (backJson.result.success === true) {
            self.orderInfoList = backJson.orderInfoList
          }
        }, response => {
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        this.uiSetItemList = [
          {uiSetId: 'tbIf_Order_Info_XiFan', columnName: 'transDt', columnDesc: '日期', columnProp: 'transDt', isVisible: '1', isVisibleDesc: '', sortNo: '99', queryCondition: '0', queryConditionDesc: '', sortNoQuery: '99', controlType: '02', controlTypeDesc: '', typeId: 'Dept_Type_KD', defaultValue: '01', required: '0', requiredDesc: '', isUnique: '0', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '1', queryVisibleDesc: '', sortNoResult: '11', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: ''},
          {uiSetId: 'tbIf_Order_Info_XiFan', columnName: 'feeAmount', columnDesc: '费用', columnProp: 'feeAmount', isVisible: '1', isVisibleDesc: '', sortNo: '99', queryCondition: '0', queryConditionDesc: '', sortNoQuery: '99', controlType: '02', controlTypeDesc: '', typeId: 'Dept_Type_KD', defaultValue: '01', required: '0', requiredDesc: '', isUnique: '0', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '1', queryVisibleDesc: '', sortNoResult: '11', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: ''},
          {uiSetId: 'tbIf_Order_Info_XiFan', columnName: 'orderNo', columnDesc: '订单号', columnProp: 'orderNo', isVisible: '1', isVisibleDesc: '', sortNo: '99', queryCondition: '0', queryConditionDesc: '', sortNoQuery: '99', controlType: '02', controlTypeDesc: '', typeId: 'Dept_Type_KD', defaultValue: '01', required: '0', requiredDesc: '', isUnique: '0', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '1', queryVisibleDesc: '', sortNoResult: '11', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: ''}
        ]
        this.orderInfoList = [
          {transDt: '20180730', feeAmount: 100, orderNo: 'xxxxxxxxxxxxxxxx'}
        ]
        this.page.totalElements = this.orderInfoList.length
        this.loadCurrentPageHistory()
        this.setVisible('03')
      }
    },
    // 根据费用类型获取对应的缴费历史记录
    getHistoryByType: function (type) {
      var self = this
      if (type === '') {
        this.orderInfoListByType = this.orderInfoList
      } else {
        this.orderInfoListByType = this.orderInfoList.filter(item => type === item.field12)
      }
      // 首次默认排序
      self.handleSortChangeHistory(self.sort)
      // 分页处理
      self.page.totalElements = self.orderInfoListByType.length
      self.loadCurrentPageHistory()
      // 设置当前选中行
      self.setCurrentRowHistory()
    },
    // 获取考试缴费账单
    examBillGet: function () {
      if (process.env.NODE_ENV === 'production') {
        var self = this
        self.axios.get('/iif/getOrderInfoCheck', { params: {
          deptId: self.global.deptId,
          keyInfo: self.global.curStudent.studentNo
        }})
        .then(function (response) {
          if (response.data.result.success === true) {
            if (response.data.orderInfoList.length > 0) {
              self.feeData = response.data.orderInfoList.filter(item => item.field12 === '02')
              for (let index = 0; index < self.feeData.length; index++) {
                self.feeData[index].field6 = false
              }
            } else {
              self.payButtonDisable = true
            }
          }
        }, response => {
        })
        .catch(function (error) {
          console.log(error)
        })
      }
    },
    // 获取查询结果配置
    getUISetQueryResult: function (form) {
      let setId = form === '01' ? 'tbIf_Order_Info_XiFan' : 'tbIf_Order_Info_XiFan_Exam'
      let sort = {prop: 'sortNoResult', order: 'ascending'}

      let list = this.uiSetItemList.filter(function (element) {
        return element.uiSetId === setId && element.queryVisible === '1'
      })

      return this.Ginkgo.sortList(list, sort)
    },
    // 列数据格式化
    dataFormatHistory: function (row, column, cellValue) {
      var columnProp = column.property
      // 根据列的property(绑定的字段属性)回查列设置
      var formatString = this.getUISetQueryResult('01').filter(function (element) {
        return element.columnProp === columnProp
      })[0].formatString

      return this.Ginkgo.format(cellValue, formatString)
    },
    dataFormatExamHistory: function (row, column, cellValue) {
      var columnProp = column.property
      // 根据列的property(绑定的字段属性)回查列设置
      var formatString = this.getUISetQueryResult('02').filter(function (element) {
        return element.columnProp === columnProp
      })[0].formatString

      return this.Ginkgo.format(cellValue, formatString)
    },
    // 列可见性
    getHeaderVisible: function (item, level, fixed) {
      return this.Ginkgo.getHeaderVisible(item, level, fixed)
    },
    // 获取同组记录
    getHeaderGroup: function (item, level, form) {
      return this.Ginkgo.getHeaderGroup(item, level, this.getUISetQueryResult(form))
    },
    // 排序(参数var={prop,order}) order: ascending  descending
    handleSortChangeHistory: function (val) {
      this.sort = val
      let sorts = this.Ginkgo.cloneObj(this.sortSet)
      sorts.pop() // 删除最后一个对象（最后一个对象根据界面列点击改变）
      sorts.push(val)
      this.orderInfoListByType = this.Ginkgo.sort(this.orderInfoListByType, sorts)
      this.loadCurrentPageHistory()
    },
    // 选中当前行
    setCurrentRowHistory: function () {
      if (this.currentIndex !== -1) {
        this.$refs.resultTable.setCurrentRow(this.tableData[this.currentIndex])
      }
    },
    // 加载当前页内容
    loadCurrentPageHistory: function () {
      this.tableData = this.orderInfoListByType.slice(this.page.number * this.page.size, (this.page.number + 1) * this.page.size)
    },
    // 查询结果每页显示条数改变事件
    handleSizeChangeHistory: function (val) {
      this.page.size = val
      this.loadCurrentPageHistory()
    },
    // 页码改变事件
    handleCurrentChangeHistory: function (val) {
      this.page.number = val - 1
      this.loadCurrentPageHistory()
    }
  }
}
</script>
<style>
.top1{width:auto; height:25px; background:#F4F4F4; padding-top:5px;}
.top_1{width:965px; height:17px; margin:0px auto; font-size:12px; padding-left:15px;}
.top_1_1{width:490px; float:left}
.top_1_1 a{ color:#666; text-decoration:none; }
.top_1_1 a:hover{ color:#000; text-decoration:underline }

.top_1_2 {width:330px; height:auto; float:right; margin-right:10px;}
#sddm
{	margin: 0 auto;
	padding: 0;
	z-index: 30;
	width:330px;
  height:auto;}

#sddm li a
{	display: block;
	width:auto;
	color:#666;
	text-align: center;
	text-decoration: none}

#sddm li a:hover
{	 color:#000; text-decoration:underline}

#sddm div
{	position: absolute;
	visibility: hidden;
	margin: 0;
	padding: 0;
	background: #EAEBD8;
	border: 1px solid #5970B2}

#sddm div a
{	position: relative;
  display: block;
  margin: 0;
  padding: 5px 10px;
  width: auto;
  white-space: nowrap;
  text-align: left;
  text-decoration: none;
  background: #EAEBD8;
  color: #2875DE;
  font: 12px arial}

#sddm div a:hover
{	background: #49A3FF;
  color: #FFF
}
.form-item {
  height: 40px;
  line-height: 40px;
  color: #303133;
  cursor: pointer;
  border-bottom: 1px solid #ebeef5;
  font-size: 14px;
  font-weight: 500;
  transition: border-bottom-color .3s;
  outline: 0;
  background-color: #fff;
  /* margin-bottom: 2px; */
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// MyBillXiFan.vue?0d24ff52